import React from "react";
import Container from "./ui/Container";
import { CheckCircle2, Mail, Instagram } from "lucide-react";

const CTASection = () => {
  const benefits = [
    "Reduce operational costs by up to 30%",
    "Automate repetitive tasks & free up your time",
    "Improve customer satisfaction & response times",
    "Scale your business without scaling your team",
  ];

  return (
    <section className="py-20 relative overflow-hidden" id="contact">
      <Container>
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background gradients */}
          <div className="absolute inset-0 bg-gradient-to-br from-tech-blue to-tech-blue/90 z-0"></div>
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAwIDEwMG0tMTAwIDBhMTAwIDEwMCAwIDEgMCAyMDAgMCAxMDAgMTAwIDAgMSAwLTIwMCAweiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utb3BhY2l0eT0iLjA1IiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=')] opacity-50 bg-center z-0"></div>
          
          <div className="relative z-10 p-8 md:p-12">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 animate-fade-in opacity-0" style={{animationDelay: "0.1s", animationFillMode: "forwards"}}>
                Ready to Work Smarter, Not Harder?
              </h2>
              
              <p className="text-lg text-blue-100 mb-8 animate-fade-in opacity-0" style={{animationDelay: "0.2s", animationFillMode: "forwards"}}>
                Let's build a solution that frees your time and grows your business. Contact us at:
              </p>
              
              <div className="flex flex-col items-center gap-4 mb-12 animate-fade-in opacity-0" style={{animationDelay: "0.3s", animationFillMode: "forwards"}}>
                <a 
                  href="mailto:techovationio@gmail.com" 
                  className="text-2xl text-white hover:text-tech-cyan transition-colors duration-300 flex items-center"
                >
                  <Mail className="w-8 h-8 mr-3" />
                  techovationio@gmail.com
                </a>
                
                <a 
                  href="https://www.instagram.com/techovation.io" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-xl text-white hover:text-tech-cyan transition-colors duration-300 flex items-center"
                >
                  <Instagram className="w-7 h-7 mr-2" />
                  @techovation.io
                </a>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto animate-fade-in opacity-0" style={{animationDelay: "0.4s", animationFillMode: "forwards"}}>
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-start bg-white/10 rounded-lg p-4">
                    <CheckCircle2 className="w-6 h-6 text-tech-cyan flex-shrink-0 mt-1 mr-3" />
                    <p className="text-blue-50 text-left">{benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-60 h-60 bg-tech-cyan opacity-20 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-60 h-60 bg-tech-orange opacity-10 rounded-full blur-3xl"></div>
        </div>
      </Container>
    </section>
  );
};

export default CTASection;
